import { useId } from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { CATEGORIE, PALETTE } from '@/tema/catalogo.js';
import { useTema } from '@/tema/contesto.js';

export function SelettoreTema() {
  const { tema, modo, impostaTema, impostaModo } = useTema();
  const idTema = useId();

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor={idTema} className="text-[13px] font-normal text-muted-foreground">
          Tema
        </Label>
        <Select value={tema} onValueChange={impostaTema}>
          <SelectTrigger id={idTema} className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {CATEGORIE.map((c) => (
              <SelectGroup key={c.id}>
                <SelectLabel>{c.etichetta}</SelectLabel>
                {PALETTE.filter((p) => p.categoria === c.id).map((p) => (
                  <SelectItem key={p.id} value={p.id}>
                    {p.etichetta}
                  </SelectItem>
                ))}
              </SelectGroup>
            ))}
          </SelectContent>
        </Select>
      </div>
      <ToggleGroup
        type="single"
        variant="outline"
        className="w-full"
        value={modo}
        onValueChange={(v) => v && impostaModo(v)}
        aria-label="Chiaro o scuro"
      >
        <ToggleGroupItem value="chiaro" className="flex-1">
          Chiaro
        </ToggleGroupItem>
        <ToggleGroupItem value="scuro" className="flex-1">
          Scuro
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
